import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Input } from "reactstrap";
import { format, startOfWeek, addDays, subDays, isToday, isSameDay } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { getTeams } from "store/actions";
import axiosInstance from "pages/Utility/axiosInstance";
import { formatDateTimeToAmPm } from "helpers/dateFormat_helper";

const CustomCalendar = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [viewMode, setViewMode] = useState('day');
  const dispatch = useDispatch();
  const teams = useSelector(state => state?.Team?.teams)
  const [calenderData, setCalenderData] = useState();


  useEffect(() => {
    dispatch(getTeams(true))
  }, [])

  const fetchCalenderData = async () => {
    try {
      const response = await axiosInstance.get('', {
        params: {
          sp: "usp_getCalendarData",
          dateFrom: selectedDate,
          mode: viewMode
        }
      })
      if (response) {
        setCalenderData(JSON.parse(response?.data?.Data?.[0]?.calendar))
      }
    } catch (error) {

    }
  }

  useEffect(() => {
    fetchCalenderData();
  }, [viewMode, selectedDate])

  useEffect(() => {
    console.log(calenderData)
  }, [calenderData])

  // Sample task data for the teams
  // const tasks = [
  //   { team: "Team D", task: "Task 1", start: "2025-01-14T11:00:00", end: "2025-01-14T13:00:00" },
  //   { team: "Team A", task: "Task 5", start: "2025-01-24T11:00:00", end: "2025-01-24T13:00:00" },
  //   { team: "Team A", task: "Task 8", start: "2025-01-24T16:00:00", end: "2025-01-24T19:00:00" },
  //   { team: "Team A", task: "Team unAvailable 9", start: "2025-01-24T16:00:00", end: "2025-01-24T19:00:00" },
  //   { team: "Team A", task: "Task 10", start: "2025-01-24T16:00:00", end: "2025-01-24T19:00:00" },
  //   { team: "Team A", task: "Task 11", start: "2025-01-24T16:00:00", end: "2025-01-24T19:00:00" },
  //   { team: "Team A", task: "Task 12", start: "2025-01-24T16:00:00", end: "2025-01-24T19:00:00" },
  //   { team: "Team D", task: "Task 6", start: "2025-01-24T11:00:00", end: "2025-01-24T13:00:00" },
  //   { team: "Team B", task: "Task 7", start: "2025-01-30T11:00:00", end: "2025-01-31T13:00:00" },
  //   { team: "Team C", task: "Task 2", start: "2025-01-14T12:00:00", end: "2025-01-14T16:00:00" },
  //   { team: "Team A", task: "Task 3", start: "2025-01-14T11:00:00", end: "2025-01-14T15:00:00" },
  // ];

  // Sample holiday data
  const holidays = [
    { date: "2025-01-15", holidayName: "Holiday 1" },
    { date: "2025-01-26", holidayName: "Holiday 2" },
  ];

  // Generate hours from 11:00 to 17:00
  const hours = [
    "00:30", "1:00", "1:30", "2:00", "2:30", "3:00", "3:30", "4:00", "4:30", "5:00", "5:30",
    "6:00", "6:30", "7:00", "7:30", "8:00", "8:30", "9:00", "9:30", "10:00", "10:30",
    "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00",
    "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30",
    "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "24:00"
  ];


  // const hours2 = [];
  // const increment = 30; // 5 minutes
  // const maxMinutes = 24 * 60; // Total minutes in 24 hours

  // for (let i = 60; i <= maxMinutes; i += increment) {
  //   hours2.push((i / 60).toFixed(2)); // Convert minutes to hours and round to 2 decimals
  // }

  // console.log(hours2?.length)

  // const hours2 = [1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10,10.5,11,11.5,12,12.5,13,13.5,14,14.5,15,15.5,16,16.5,17,17.5,18,18.5,19,19.5,20,20.5,21,21.5,22,22.5,23,23.5]

  const hours2 = [];
  const increment = .125; // 15 minutes in fractional hours

  for (let i = 0; i < 24; i += increment) {
    hours2.push(parseFloat(i.toFixed(2))); // Keep 2 decimal places for precision
  }


  // Get the start of the week and the next week days for the selected date
  const getWeekDays = (date) => {
    const startOfWeekDate = startOfWeek(date, { weekStartsOn: 6 }); // Start of week (Monday)
    return Array.from({ length: 30 }, (_, i) => addDays(startOfWeekDate, i));
  };

  // Handle the "Today" button click to set the selected date to today
  const handleTodayClick = () => {
    setSelectedDate(new Date());
  };

  // Go to the previous date
  const handlePrevDate = () => {
    const nextDate = subDays(selectedDate, 1);
    const midnightDate = new Date(nextDate);
    midnightDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00.000Z
    setSelectedDate(midnightDate);
  };

  // Go to the next date
  const handleNextDate = () => {
    const nextDate = addDays(selectedDate, 1);
    const midnightDate = new Date(nextDate);
    midnightDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00.000Z
    setSelectedDate(midnightDate);
  };

  // Handle view mode toggle
  const handleToggleDay = () => {
    setViewMode('day');
  };

  const handleToggleWeek = () => {
    setViewMode('week')
  }

  // Filter tasks based on the selected date or week
  const filterTasksByDate = (task, date) => {
    const taskStartDate = new Date(task.scheduledStartDateTime);
    const taskEndDate = new Date(task.scheduledEndDateTime);
    return isSameDay(taskStartDate, date) || isSameDay(taskEndDate, date) || (taskStartDate <= date && taskEndDate >= date);
  };

  // Get column span based on task start and end times
  const getColumnSpan = (task) => {
    const taskStartHour = new Date(task.start).getHours();
    const taskEndHour = new Date(task.end).getHours();
    return taskEndHour - taskStartHour;
  };

  // Check if the date is a holiday
  const isHoliday = (date) => {
    return calenderData?.holidays?.some((holiday) => format(new Date(holiday.date), 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd'));
  };

  function getDecimalTime(date) {
    const hours = date.getHours(); // Get the hours
    const minutes = date.getMinutes(); // Get the minutes

    const decimalTime = hours + (minutes / 60);

    return Math.round(decimalTime * 4) / 4;
  }

  return (
    <Container fluid className="page-content mt-3" style={{ direction: 'ltr' }}>
      <Row className="mb-4 d-flex justify-content-between align-items-center gap-3" >
        {/* "Today" button */}
        <Col xs="auto">
          <Button color="primary" onClick={handleTodayClick}>
            Today
          </Button>
        </Col>

        {/* Date Picker */}
        <Col xs="auto" className="d-flex justify-content-center align-items-center">
          <div className="d-flex justify-content-between gap-2 align-items-center">
            <Button color="secondary" onClick={handlePrevDate}> &lt; </Button>
            <Input
              type="date"
              value={format(selectedDate, 'yyyy-MM-dd')}
              onChange={(e) => setSelectedDate(new Date(e.target.value))}
              style={{ width: '150px' }}
            />
            <Button color="secondary" onClick={handleNextDate}> &gt; </Button>
          </div>
        </Col>

        {/* View Mode Toggle */}
        <Col xs="auto">
          <Button color={viewMode === 'day' ? 'primary' : 'secondary'} onClick={handleToggleDay} className="mx-2">
            Day View
          </Button>
          <Button color={viewMode === 'week' ? 'primary' : 'secondary'} onClick={handleToggleWeek} className="mx-2">
            Week View
          </Button>
        </Col>
      </Row>

      {/* // Table Header: Update to make sure the column spans correctly */}
      <div style={{ maxHeight: '520px', overflowY: 'auto' }}>
        <div className="d-flex text-center" 
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 20,
            width:"max-content"
          }}>
          <div className="border p-2 fw-bold bg-white" 
          style={{ 
            width: "150px", 
            flexShrink: 0, 
            position: 'sticky',
            left: 0,
            zIndex: 20
            }}>Teams</div>
          {viewMode === 'day'
            ? hours.map((hour) => (
              <div key={hour} className="border p-2 fw-bold bg-white" style={{ width: "100px", flexShrink: 0 }}>
                {hour}
              </div>
            ))
            : getWeekDays(selectedDate).map((date, index) => (
              <div key={index} className="border p-2 fw-bold bg-white" style={{ width: "160px", flexShrink: 0 }}>
                {format(date, 'EEE MM/dd')}
              </div>
            ))}
        </div>


        {teams?.Data?.map(item => item?.teamName).map((team) => (
          <div key={team} className="d-flex text-center " style={{width:"max-content"}}>

            <div
              className="border p-2 fw-bold d-flex align-items-center justify-content-center"
              style={{
                width: '150px',
                flexShrink: 0,
                position: 'sticky',
                left: 0,
                zIndex: 19,
                backgroundColor: 'white',
              }}
            >
              {team}
            </div>
            {viewMode === 'day' ? (
              <div
                className="d-flex"
                style={{
                  position: 'relative',
                  width: `${hours2.length * 25}px`,
                  minHeight: '70px',
                  flexShrink: 0,
                  borderTop: '1px solid lightgray',
                }}
              >
                {/* ✅ Holiday background layer */}
                {isHoliday(selectedDate) && (() => {
                  const holidayData = calenderData?.holidays?.find(
                    (holiday) =>
                      format(new Date(holiday.date), 'yyyy-MM-dd') === format(selectedDate, 'yyyy-MM-dd')
                  );

                  return (
                    <div
                      style={{
                        position: 'absolute',
                        top: '15%',
                        bottom: '15%',
                        width: '100%',
                        backgroundColor: holidayData?.reason === 'Scheduled Off Day' ? 'gray' : '#ec4561',
                        opacity: 1,
                        zIndex: 0,
                      }}
                      title={holidayData?.reason || 'Holiday'}
                    />
                  );
                })()}

                {/* ✅ Work Order Blocks */}
                {calenderData?.workorders
                  ?.filter(
                    (task) =>
                      task.teamName === team &&
                      filterTasksByDate(task, selectedDate) &&
                      task.scheduledStartDateTime &&
                      task.scheduledEndDateTime
                  )
                  ?.map((task) => {
                    const startDecimal = getDecimalTime(new Date(task.scheduledStartDateTime));
                    const endDecimal = getDecimalTime(new Date(task.scheduledEndDateTime));
                    
                    // Each hour is split into 8 chunks (15 mins = 0.125)
                    const blockSizePx = 25;
                    
                    // Calculate position by direct math instead of relying on `findIndex`
                    const leftPos = Math.round(startDecimal / 0.125) * blockSizePx;
                    const rightPos = Math.round(endDecimal / 0.125) * blockSizePx;
                    
                    const blockWidth = Math.max(rightPos - leftPos, blockSizePx); // Ensure at least 1 block wide
                    

                    return (
                      <div
                        key={`${team}-${task.workOrderNumber}`}
                        style={{
                          position: 'absolute',
                          left: `${leftPos}px`,
                          width: `${blockWidth}px`,
                          top: '15%',
                          bottom: '15%',
                          backgroundColor: task?.workOrderNumber?.includes("TeamUnavailability")
                            ? "#ff914d"
                            : '#90ee90',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          color: '#38393b',
                          borderRadius: '0px',
                          borderLeft: '1px solid #69cd69',
                          borderRight: '1px solid #69cd69',
                          textAlign: 'center',
                          padding: '2px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          zIndex: 1,
                        }}
                        title={
                          task?.workOrderNumber?.includes("TeamUnavailability")
                            ? `Type: ${task?.workOrderStatus}\nReason: ${task?.reason}\n${formatDateTimeToAmPm(
                                task?.actualscheduledStartDateTime
                              )} to ${formatDateTimeToAmPm(task?.actualscheduledEndDateTime)}`
                            : `WorkOrder Number: ${task?.workOrderNumber}\nCustomer Name: ${task?.customerNameEng} (${task?.customerNameAr})\n${formatDateTimeToAmPm(
                                task?.actualscheduledStartDateTime
                              )} to ${formatDateTimeToAmPm(task?.actualscheduledEndDateTime)}`
                        }
                      >
                        {task.workOrderNumber}
                      </div>
                    );
                  })}
              </div>
            ) 
              : getWeekDays(selectedDate)?.map((date, index) => (
                <div
                  key={index}
                  className=""
                  style={{
                    width: '160px',
                    minHeight: "70px",
                    flexShrink: 0,
                    backgroundColor: isHoliday(date) ? 'gray' : 'transparent',
                    border: isHoliday(date) ? "none" : "1px solid lightgray"
                  }}
                >
                  {isHoliday(date) ? (() => {
                      const holidayData = calenderData?.holidays?.find(
                        (holiday) =>
                          format(new Date(holiday.date), 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd')
                      );

                      return (
                        <div
                          style={{
                            backgroundColor:
                              holidayData?.reason === 'Scheduled Off Day'
                                ? 'gray'
                                : '#ec4561', 
                            color: 'white',
                            textAlign: 'center',
                            padding: '10px 0',
                            borderRadius: '0px',
                            gridColumn: 'span 24',
                            height: "100%",
                            width: "100%",
                          }}
                          title={holidayData?.reason || 'Holiday'}
                        >
                          {/* {holidays.find((holiday) => format(new Date(holiday.date), 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd'))?.holidayName || 'Holiday'} */}
                                    
                          {/* Optional text here */}
                        </div>
                      );
                    })(): (
                    calenderData?.workorders?.map(
                      (task) =>
                        task.teamName === team &&
                        filterTasksByDate(task, date) && (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            key={`${team}-${index}-${task.workOrderNumber}`}
                            style={{
                              backgroundColor: task?.workOrderNumber?.includes("TeamUnavailability") ? "#ff914d" : '#90ee90',
                              border: '1px solidrgb(19, 163, 74)',
                              borderRadius: '5px',
                              margin: "5px auto",
                              height: "auto",
                              textAlign: "center",
                              fontSize: "12px",
                              minHeight: "40px",
                              width: "120px",
                              color: "white"
                            }}
                            title={task?.workOrderNumber?.includes("TeamUnavailability") ? `Type: ${task?.workOrderStatus}\nReason: ${task?.reason}\n${formatDateTimeToAmPm(task?.actualscheduledStartDateTime)} to ${formatDateTimeToAmPm(task?.actualscheduledEndDateTime)}` : `WorkOrder Number: ${task?.workOrderNumber}\nCustomer Name: ${task?.customerNameEng} (${task?.customerNameAr})\n${formatDateTimeToAmPm(task?.actualscheduledStartDateTime)} to ${formatDateTimeToAmPm(task?.actualscheduledEndDateTime)}`}
                          >
                            <p>{task.workOrderNumber}</p>
                          </div>
                        )
                    )
                  )}
                </div>
              ))}
          </div>
        ))}
      </div>

    </Container>
  );
};

export default CustomCalendar;
